import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { SettingForm } from '@/features/system-settings-form'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/administration/settings/create')({
  staticData: {
    meta: {
      title: 'Создать настройку',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Создать настройку')}>
      <SettingForm mode="create" onClose={close} />
    </Offcanvas>
  )
}
